import React from "react";

import {
  DIRECT_LABOR_FIXED_COLUMNS,
  DIRECT_LABOR_FIXED_TOTAL_WIDTH,
} from "./weeklyEACColumns";

export default function WeeklyEACDirectLaborFixedTable({ employeeDetails }) {
  return (
    <table
      className="firstTableFin weeklyEac"
      cellPadding={0}
      cellSpacing={0}
      style={{ width: DIRECT_LABOR_FIXED_TOTAL_WIDTH, tableLayout: "fixed" }}
    >
      <thead>
        <tr>
          {DIRECT_LABOR_FIXED_COLUMNS.map((column) => (
            <th
              key={column.label}
              style={{ width: column.width, minWidth: column.width }}
            >
              {column.label}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {employeeDetails.map((employee) => (
          <tr key={employee.dlId}>
            {DIRECT_LABOR_FIXED_COLUMNS.map((column) => (
              <td
                key={column.label}
                style={{ minWidth: column.width, maxWidth: column.width }}
                title={column.accessor(employee) ?? ""}
              >
                {column.accessor(employee) ?? ""}
              </td>
            ))}
          </tr>
        ))}
        <tr className="totalRow">
          <td colSpan={DIRECT_LABOR_FIXED_COLUMNS.length}>
            Total Direct Labor Cost
          </td>
        </tr>
      </tbody>
    </table>
  );
}
